import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Button from 'react-bootstrap/Button';
import { tabletValidationSchema } from '../../validations-modules/asset.js'
import { FieldsAssetTablet } from '../fields-asset/FieldsAssetTablet.js'

export const FormAssetTablet = ({ formData, setFormData,  nextStep, prevStep }) => {

  const [direction, setDirection] = useState('back');

  return (
    <>
      <Formik
        initialValues={formData}

        onSubmit={(values, {setSubmitting, resetForm}) => {
            // When button submits form and form is in the process of submitting, submit button is disabled
            setSubmitting(true);
            
            setFormData(prev => {
              return {...prev, ...values}
            });

            // Resets form after submission is complete
            resetForm();

            // Sets setSubmitting to false after form is reset
            setSubmitting(false);

            direction === 'back' ? prevStep() : nextStep();

        }}

        validationSchema={tabletValidationSchema}
      >
        
        {({ isSubmitting, errors, touched, values, resetForm, handleSubmit, setFieldValue, setFieldTouched }) => 
        (
          <FieldsAssetTablet handleSubmit={handleSubmit} touched={touched} errors={errors} values={values} setFieldValue={setFieldValue} setFieldTouched={setFieldTouched}>
            <div>
              <Button
                type='submit'
                variant='primary'
                onClick={() => setDirection('back')}
                disabled={isSubmitting}
                className="mr-1">
                Indietro
              </Button>
              <Button 
                type='submit'
                variant='primary'
                onClick={() => setDirection('forward')}
                disabled={isSubmitting}>
                Avanti
              </Button>
            </div>
          </FieldsAssetTablet>
        )}
      </Formik>
    </>
  );
};

FormAssetTablet.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired
};